import React from 'react';
import { Box } from '@mui/material';
import { PageContainer, PageCard } from '../../common/components';
import { RecurringTaskCreateHeader } from '../components/RecurringTaskForm/headers';
import { RecurringTaskCreateForm } from '../components/RecurringTaskForm';
import { useRecurringTaskPrefill } from '../hooks/useRecurringTaskPrefill';

/**
 * RecurringTaskCreate - Main page component for creating new recurring tasks
 * Supports query params for pre-filling from asset page:
 *   ?category=PM&assetId=...&assetTag=...&assetName=...&centerId=...
 */
const RecurringTaskCreate: React.FC = () => {
  useRecurringTaskPrefill();

  return (
    <PageContainer>
      <Box display="flex" justifyContent="center">
        <PageCard>
          <RecurringTaskCreateHeader />
          <RecurringTaskCreateForm />
        </PageCard>
      </Box>
    </PageContainer>
  );
};

export default RecurringTaskCreate;
